// Detailed brand-page content (bilingual). Keyed by brand.slug.

export const BRAND_PAGES = {
  coz: {
    tagline: {
      ar: "فن الحلويات الفاخرة",
      en: "Experience the Art of Cozy Delights",
    },
    hero: {
      ar: "في مختارات زيد، التفاصيل الصغيرة هي أكثر ما يهمنا.",
      en: "At Collection of Zaid, it's all about the small details.",
    },
    about: {
      ar:
        "نحن هنا بمساعدة فريقنا المتخصص لإعداد أجود أصناف الآيس كريم والكيك والشوكولاتة، ونقدم لك ولضيوفك تجربة تموين فريدة لا تُنسى في جميع مناسباتكم السعيدة. مكوّناتنا مأخوذة من أفضل الموردين حول العالم لضمان تجربة استثنائية في كل مرة.",
      en:
        "With our specialised team we prepare the finest ice cream, cakes and chocolate — delivering a unique catering and unforgettable dining experience for all your happy occasions. Our creations are crafted using the finest ingredients sourced from top suppliers worldwide, guaranteeing a consistently exceptional experience.",
    },
    vision: {
      ar: "أن نكون الوجهة المثالية لعشاق الحلويات الفريدة التي تأسر الحواس وترتقي بكل تجربة.",
      en: "To be the ultimate destination for those seeking exceptional desserts that captivate the senses and elevate every experience.",
    },
    categoriesTitle: { ar: "أصنافنا", en: "Our Categories" },
    categories: [
      { ar: "كيك الآيس كريم", en: "Ice Cream Cake" },
      { ar: "كيك", en: "Cake" },
      { ar: "شوكولاتة", en: "Chocolate" },
      { ar: "هدايا", en: "Gifts" },
      { ar: "باقات المناسبات", en: "Occasional Packages" },
    ],
    locationsTitle: { ar: "فروعنا", en: "Our Locations" },
    branches: [
      { ar: "فرع الروضة", en: "Al-Rawdah Branch", city: { ar: "جدة", en: "Jeddah" } },
      { ar: "فرع البساتين", en: "Al-Bassateen Branch", city: { ar: "جدة", en: "Jeddah" } },
    ],
    cloudKitchens: {
      count: 40,
      cities: { ar: ["جدة", "مكة", "الطائف"], en: ["Jeddah", "Makkah", "Taif"] },
      label: { ar: "مطبخ سحابي حول المملكة", en: "Cloud Kitchens across the Kingdom" },
    },
  },

  zed: {
    tagline: { ar: "طازج، صحي", en: "Fresh Done Right" },
    hero: {
      ar: "امتياز سعودي بنكهة عالمية",
      en: "A Saudi Franchise with a Global Flavor",
    },
    about: {
      ar:
        "علامة سعودية تأسست عام ٢٠١٩ لتقدّم حلولاً عصرية في مجال Grab & Go. انتشرت عبر أكثر من ٦٠ موقعاً في جدة ومكة والطائف والرياض، مقدّمةً وجبات عالية الجودة، سناكات، قهوة وحلويات تُحضّر في منشأتنا المركزية. تصل منتجاتنا إلى عملائنا بسهولة عبر أجهزة البيع الذاتي، الكاونترات، وبرامج الاشتراك.",
      en:
        "ZED is a Saudi-born brand founded in 2019, redefining modern Grab & Go food. With 60+ locations across Jeddah, Makkah, Taif and Riyadh, we deliver fresh meals, snacks, desserts and specialty coffee — all prepared in our central facility and served through vending machines, counters and subscription programs.",
    },
    stats: [
      { value: 6, suffix: "+", ar: "سنوات من الإزدهار", en: "Years of Growth" },
      { value: 60, suffix: "+", ar: "موقع تشغيل", en: "Operating Locations" },
      { value: 85, suffix: "K+", ar: "عميل راضٍ شهرياً", en: "Happy Customers / Month" },
      { value: 330, suffix: "K+", ar: "منتج يُباع شهرياً", en: "Products Sold / Month" },
      { value: 45, suffix: "K+", ar: "مشروب ساخن شهرياً", en: "Hot Drinks / Month" },
      { value: 55, suffix: "%", ar: "عملاء يعودون شهرياً", en: "Monthly Retention" },
    ],
    franchiseTitle: { ar: "خطط الامتياز", en: "Franchise Formats" },
    franchiseIntro: {
      ar: "استثمر في علامة سعودية بنكهة عالمية عبر أحد نماذجنا:",
      en: "Invest in a Saudi brand with a global flavour through one of our formats:",
    },
    formats: [
      {
        title: { ar: "درايف - ثرو", en: "Drive-Thru" },
        desc: {
          ar: "خدمة سريعة للمتنقلين مع قائمة مختصرة لسهولة التوقف والشراء.",
          en: "Fast Drive-thru service designed for travellers with a menu optimised for quick stops.",
        },
        fee: "100K",
        royalty: "7%",
        marketing: "2%",
      },
      {
        title: { ar: "متجر مستقل", en: "Walk-in (with Kitchen)" },
        desc: {
          ar: "متجر مستقل يقدّم قائمة زد الكاملة ويمنح تجربة العلامة بكافة تفاصيلها.",
          en: "A complete standalone shop offering the full ZED menu and brand experience.",
        },
        fee: "150K",
        royalty: "7%",
        marketing: "2%",
      },
      {
        title: { ar: "ركن داخل تموينات / كشك", en: "Walk-in (Shop-in-Shop / Kiosk)" },
        desc: {
          ar: "ركن صغير داخل التموينات أو كشك مثالي للمدارس والجامعات والمكاتب.",
          en: "A shop-in-shop inside convenience stores, or a kiosk ideal for schools, universities and offices.",
        },
        fee: "100K",
        royalty: "7%",
        marketing: "2%",
      },
    ],
    franchiseEmail: "franchise@ezdhar-ksa.com",
  },

  "zed-meals": {
    tagline: { ar: "وجبات زد ميلز متوازنة", en: "ZED Meals — Done Right" },
    hero: {
      ar: "أسلوب حياة قائم على التوازن",
      en: "A lifestyle built on balance",
    },
    about: {
      ar:
        "زد ميلز هو تطبيق اشتراكات شهرية يسهّل حياتك اليومية. مع أكثر من ١٠٠٠ مشترك شهرياً، نقدّم وجبات صحية ومتوازنة تُحضّر بعناية لتجمع بين الجودة والطعم والراحة. يضمن فريق خدمة العملاء تجربة سلسة، مع قائمة يومية متنوعة تلبي مختلف الأذواق.",
      en:
        "ZED Meals is a monthly subscription app designed to simplify your daily life. With 1,000+ monthly subscribers, we provide carefully crafted, healthy and balanced meals that combine quality, taste and convenience — supported by a diverse daily menu and a dedicated customer team.",
    },
    stats: [
      { value: 100, suffix: "K+", ar: "وجبة تم توصيلها", en: "Meals Delivered" },
      { value: 10, suffix: "K+", ar: "شخص تغيّرت حياتهم للأفضل", en: "Lives Transformed" },
      { value: 1000, suffix: "+", ar: "مشترك شهرياً", en: "Monthly Subscribers" },
      { value: 50, suffix: "+", ar: "شركة نخدمها", en: "Corporate Clients" },
    ],
    citiesTitle: { ar: "التغطية", en: "Delivery Coverage" },
    cities: {
      ar: ["جدة", "مكة", "الطائف", "المدينة"],
      en: ["Jeddah", "Makkah", "Taif", "Al Madinah"],
    },
    valuesTitle: { ar: "لماذا زد ميلز؟", en: "Why ZED Meals?" },
    values: [
      {
        ar: "وجبات صحية ومتوازنة تناسب جميع الأذواق.",
        en: "Healthy, balanced meals for every taste.",
      },
      {
        ar: "توصيل يومي مع استلام مرن من فروع متعددة.",
        en: "Daily delivery with flexible pickup from multiple branches.",
      },
      {
        ar: "تطبيق سهل وسريع للاشتراك.",
        en: "Easy-to-use subscription app.",
      },
      {
        ar: "فريق خدمة عملاء متخصّص.",
        en: "Dedicated customer service team.",
      },
    ],
    juniorTitle: { ar: "زد جونيور — لطلاب المدارس", en: "ZED Junior — For School Kids" },
    juniorDesc: {
      ar:
        "برنامج اشتراك شهري ضمن زد ميلز مصمم خصيصاً لتقديم وجبات صحية ولذيذة يحبها الأطفال في المدارس، تجمع بين التغذية السليمة، المكونات الطازجة، والنكهات المحببة. تسهيل حقيقي لأولياء الأمور لتحضير وجبات مدرسية صحية كل يوم.",
      en:
        "A monthly subscription program under ZED Meals designed to deliver balanced, delicious and kid-friendly daily meals for school children — combining nutrition, fresh ingredients and flavours kids love. A real relief for busy parents.",
    },
    juniorFeatures: [
      {
        ar: "الأطفال في المراحل الدراسية (من ٤ إلى ١٢ سنة)",
        en: "School-age children (4–12 years)",
      },
      {
        ar: "تحديد الحساسيات والبدائل واستبعاد المكونات غير المحببة",
        en: "Allergy filters, alternatives and ingredient exclusions",
      },
      {
        ar: "توصيل مبكر قبل الذهاب للمدرسة أو مسائي لليوم التالي",
        en: "Early morning delivery or scheduled next-day evening delivery",
      },
      {
        ar: "باقات أسبوعية أو شهرية أو تجريبية",
        en: "Weekly, monthly or trial plans",
      },
    ],
    contact: {
      phone1: "0541140818",
      phone2: "0569512739",
    },
    appCta: { ar: "حمّل تطبيقنا", en: "Download our App" },
    knowMore: { ar: "تعرّف علينا أكثر", en: "Get to know us" },
  },
};

export const BRAND_STATUS_LABEL = {
  closed: { ar: "مغلق مؤقتاً", en: "Temporarily Closed" },
  coming_soon: { ar: "قريباً", en: "Coming Soon" },
};
